import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { first, map } from 'rxjs/operators';
import { PUBLIC_ROUTE } from 'src/app/constants/route.constants';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(
    private $router: Router,
    private $profile: ProfileService,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.$handler();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.$handler();
  }
  private $handler() {
    if (!this.$profile.token) {
      this.$router.navigate(PUBLIC_ROUTE.url);
      return false;
    }
    if (!this.$profile.isProfileLoaded) {
      this.$profile.fetchProfile();
    }
    return this.$profile.changes.pipe(first(), map(data => {
      if (!data) {
        this.$router.navigate(PUBLIC_ROUTE.url);
      }
      return !!data;
    }));
  }
}
